import { useEffect } from 'react';

const STYLE_ID = 'nsdi-search-hide-title';

export const useHideSearchPageChrome = (isEditMode: boolean): void => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    if (isEditMode) {
      document.getElementById(STYLE_ID)?.remove();
      return;
    }

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #page-document > h1:first-child,
      #page-document > .documentFirstHeading:first-child { display: none !important; }
      .breadcrumbs, nav.breadcrumbs, section.breadcrumbs,
      .plone-breadcrumb, #portal-breadcrumbs { display: none !important; }
    `;
    document.head.appendChild(style);

    return () => {
      document.getElementById(STYLE_ID)?.remove();
    };
  }, [isEditMode]);
};
